import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";

type Issue3MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue3Material = (props: Issue3MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          これまでのLessonを通じて、どんな場面でどんな力が身についたか、どのように力を発揮できたかを振り返ってまとめよう。
        </p>
      </div>
      {question1 && <TextArea />}
    </div>
  );
};
export default Issue3Material;
